import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast, Toaster } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";
import { GoogleSignInButton } from "./AuthCallback";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2" style={{ background: "var(--bg)" }}>
      <Toaster theme="dark" />
      <div className="hidden md:block relative grid-bg border-r" style={{ borderColor: "var(--border)" }}>
        <div className="absolute inset-0 p-12 flex flex-col justify-between">
          <Link to="/" data-testid="back-home" className="font-display font-black text-2xl tracking-tighter">
            MY NEXUS<span style={{ color: "var(--accent)" }}> </span>CARD
          </Link>
          <div>
            <div className="overline mb-3">// log in to your operating room</div>
            <h2 className="font-display font-black text-5xl tracking-tighter leading-none">
              Where every<br />contact<br />converts.
            </h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <Link to="/" className="md:hidden font-display font-black text-2xl tracking-tighter block mb-10">
            MY NEXUS<span style={{ color: "var(--accent)" }}> </span>CARD
          </Link>
          <div className="overline mb-4">// sign in</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mb-10">Welcome back.</h1>

          <label className="label-base">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base mb-6" autoComplete="email" />

          <label className="label-base">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-base mb-2" autoComplete="current-password" />
          <div className="mb-6 flex justify-end">
            <Link to="/forgot-password" data-testid="forgot-link" className="overline hover:text-white">forgot password? →</Link>
          </div>

          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-primary w-full flex items-center justify-between">
            {busy ? "Signing in..." : "Sign in"} <ArrowRight weight="bold" />
          </button>

          <div className="my-6 flex items-center gap-3">
            <div className="flex-1 border-t" style={{ borderColor: "var(--border)" }}></div>
            <span className="overline">or</span>
            <div className="flex-1 border-t" style={{ borderColor: "var(--border)" }}></div>
          </div>
          <GoogleSignInButton testid="login-google" />

          <p className="mt-8 text-sm text-[#C7DDE5]">
            No account? <Link to="/register" data-testid="link-register" className="text-white underline">Create one</Link>
          </p>
          <div className="mt-6 pt-6 border-t flex gap-4" style={{ borderColor: "var(--border)" }}>
            <Link to="/terms" className="overline hover:text-white">Terms</Link>
            <Link to="/privacy" className="overline hover:text-white">Privacy</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
